
<script>
import INTERFACE_MODEL_BASE from '@/Interface/index';
export default {

    /** 上传图片 - model **/
    UploadImages(item) {
        var file;
        var url;
        var obj=document.querySelector('#TTLFiles');
        obj.click(); //点击触发上传图片
        obj.addEventListener('change',function(e) {
            //获取上传的图片
            file=e.target.files[0];
            e.target.value=null; //清空数据
            //上传图片到接口操作
            INTERFACE_MODEL_BASE.UPLOAD_FILES({imageType:item.imageType,File:file}).then((res) => {
                if(res.status > 0) return false;
                url=res.data.url;
                return url;
            });
        });
    },

}
</script>